import { createSystem, defaultBaseConfig, defaultConfig } from '@chakra-ui/react';

import { breakpoints, layerStyles, semanticTokens, tokens } from './theme';

const CHAKRA_RESEARCH_SYSTEM_CLASSNAME = 'ck-bwr-root';

const researchSystem = createSystem(defaultBaseConfig, {
    strictTokens: false,
    preflight: {
        level: 'element',
        scope: '[class*="chakra-"]',
    },
    cssVarsPrefix: 'ck-bwr' /** short for: chakra blockworks research */,
    cssVarsRoot: `:where(:root, :host, .${CHAKRA_RESEARCH_SYSTEM_CLASSNAME})`,
    theme: {
        keyframes: defaultConfig.theme?.keyframes,
        recipes: defaultConfig.theme?.recipes,
        slotRecipes: defaultConfig.theme?.slotRecipes,
        animationStyles: defaultConfig.theme?.animationStyles,
        layerStyles,
        tokens,
        semanticTokens,
        breakpoints,
    },
});

export { researchSystem, CHAKRA_RESEARCH_SYSTEM_CLASSNAME };
/** export default for chakra-cli type generation */
export default researchSystem;
